import { cn } from '../../lib/cn';

export function Card({ className, padding='p-5', children, ...props }) {
  return (
    <div className={cn('bg-[var(--bg-card)] border border-[var(--border)] rounded-[var(--radius-md)] shadow-[var(--shadow-sm)]', padding, className)} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ className, children }) {
  return <div className={cn('flex items-center justify-between mb-4', className)}>{children}</div>;
}

export function CardTitle({ className, children }) {
  return <h3 className={cn('text-[15px] font-semibold text-[var(--text-primary)]', className)}>{children}</h3>;
}
